import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import BrowserProtocol from 'farce/BrowserProtocol';
import React from 'react';
import createFarceRouter from './createFarceRouter';
import resolver from './resolver';
export default function createBrowserRouter(options) {
  var FarceRouter = createFarceRouter(_extends({}, options, {
    historyProtocol: new BrowserProtocol()
  }));

  function BrowserRouter(props) {
    return /*#__PURE__*/React.createElement(FarceRouter, _extends({
      resolver: resolver
    }, props));
  }

  return BrowserRouter;
}